import { render, staticRenderFns } from "./_dbConfigModal.vue?vue&type=template&id=e8e9e3f8"
import script from "./_dbConfigModal.vue?vue&type=script&lang=js"
export * from "./_dbConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports